import { createApiClient } from '@upme/api-client';
import { authAdapter } from '../features/auth/memory-access-adapter';

// ky's prefixUrl is parsed via `new URL(input, prefixUrl)` — a bare path like
// "/api" is not a valid absolute URL. В prod-сборке задаётся VITE_API_BASE_URL
// (например https://api.upme.click). В dev/тестах резолвим против
// window.location.origin → vite-proxy /api или MSW в jsdom.
const fallbackOrigin =
  typeof window !== 'undefined' && window.location?.origin ? window.location.origin : 'http://localhost';

export const api = createApiClient({
  prefixUrl: import.meta.env.VITE_API_BASE_URL ?? `${fallbackOrigin}/api`,
  authAdapter,
});
